import React from 'react';
// Components
import CbTeamOwnershipTransfer from 'components/common/CbTeamOwnershipTransfer/CbTeamOwnershipTransfer';

const CbTeamOwnership = (): JSX.Element => {
  return <CbTeamOwnershipTransfer />;
};

export default CbTeamOwnership;
